<template>
  <div class="icons-info-block">
    <el-tooltip effect="light" content="卡片信息" placement="top">
      <div
        class="icons"
        @mouseover="changeSecondUrl(true)"
        @mouseleave="changeSecondUrl(false)"
        @click="handleInfo"
      >
        <img :src="iconSecondUrl" alt="" />
      </div>
    </el-tooltip>
    <el-dialog
      :title="infoTitle"
      :visible.sync="infoDialogVisible"
      :width="widthShow"
      :before-close="handleClose"
      :modal-append-to-body="false"
      :modal="true"
    >
      <div class="dialog-text-block">
        <p v-for="(text, index) in details" :key="index">{{ text }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    details: {
      default: "--",
    },
    infoTitle: {
      default: "--",
    },
  },
  data() {
    return {
      iconSec: false,
      infoDialogVisible: false,
    };
  },
  computed: {
    iconSecondUrl() {
      return this.iconSec
        ? require("../../../assets/img/icons/lightabout.svg")
        : require("../../../assets/img/icons/about.svg");
    },
  },
  methods: {
    changeSecondUrl(show) {
      this.iconSec = show;
    },
    handleInfo() {
      this.infoDialogVisible = true;
    },
    handleClose() {
      this.infoDialogVisible = false;
    },
  },
};
</script>

<style scoped>
.icons-info-block {
  display: flex;
  display: flex;
  justify-content: space-between;
  box-shadow: 0px 0px 6px 0px #7580be;
  border-radius: 4px;
  border: 1px solid #1582a3;
  cursor: pointer;
}
.icons {
  padding: 8px 6px 6px 6px;
}
.dialog-text-block {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333;
  font-size: 15px;
  padding:16px 25px;
}
.dialog-text-block p {
  line-height: 20px;
  margin-bottom: 6px;
}
.icons-info-block >>> .el-dialog__body {
  border-top: 1px solid rgba(0, 0, 0, 0.09) !important;
  height: 70%;
  width: 92%;
  padding: 0;
}
.icons-info-block >>> .el-dialog {
  overflow: hidden;
  height: 50%;
}
@media (min-width: 1279px) and (max-width: 1365px) {
    .icons{
      padding: 1px 6px 1px 6px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dataChart/iconsBlock/iconsInfo.vue